import { toast } from "vue-sonner";

import {
  isNotDecidableError,
  isRateLimitedError,
  NOT_DECIDABLE_MESSAGE,
  TOO_MANY_ATTEMPTS_MESSAGE,
} from "@/shared/api/errors";

export { toast };

type AxiosLikeError = {
  response?: { data?: { message?: string } };
  message?: string;
};

function isAxiosError(e: unknown): e is AxiosLikeError {
  return typeof e === "object" && e !== null && ("response" in e || "message" in e);
}

function extractMessage(err: unknown, fallback: string): string {
  if (isRateLimitedError(err)) {
    return TOO_MANY_ATTEMPTS_MESSAGE;
  }

  if (isNotDecidableError(err)) {
    return NOT_DECIDABLE_MESSAGE;
  }

  if (isAxiosError(err)) {
    const apiMessage = err.response?.data?.message;

    if (typeof apiMessage === "string" && apiMessage.length > 0) {
      return apiMessage;
    }

    if (typeof err.message === "string" && err.message.length > 0) {
      return err.message;
    }
  }

  return fallback;
}

export function toastError(err: unknown, fallback: string): void {
  toast.error(extractMessage(err, fallback));
}

export function toastSuccess(message: string): void {
  toast.success(message);
}

export function toastInfo(message: string): void {
  toast.info(message);
}
